<template>
  <b-container fluid>
    <b-row>
      <b-col :lg="cols">
        <card>
          <TableActionHeader
            v-on:filterChange="onFilterChange"
            v-on:newItem="onNewItem"
          ></TableActionHeader>
          <DeviceTable
            :filter="filter"
            v-on:selectItem="onSelectItem"
          ></DeviceTable>
        </card>
      </b-col>
      <b-col v-if="showForm">
        <card>
          <CardHeader :title="formTitle" v-on:close="onClose"></CardHeader>
          <DeviceForm
            ref="deviceEditor"
            :item="item"
            :action="formType"
          ></DeviceForm>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DeviceTable from '@/components/Devices/Device/DeviceTable.vue'
import DeviceForm from '@/components/Devices/Device/DeviceForm.vue'
import TableActionHeader from '@/components/Misc/TableActionHeader'
import CardHeader from '@/components/Misc/CardHeader'
import i18n from '@/i18n'

export default {
  name: 'Devices',
  components: {
    DeviceTable,
    DeviceForm,
    TableActionHeader,
    CardHeader,
  },
  data: function () {
    return {
      showForm: true,
      cols: 8,
      filter: null,
      defaultFormData: {
        deviceId: null,
        name: null,
        description: null,
        type: null,
        infopoint: null,
        location: {
          latitude: null,
          longitude: null,
        },
      },
      item: {
        deviceId: null,
        name: null,
        description: null,
        type: null,
        infopoint: null,
        location: {
          latitude: null,
          longitude: null,
        },
      },
      formType: 'new',
    }
  },

  methods: {
    showEditor: function (show, type) {
      this.showForm = show
      this.formType = type
      this.cols = this.showForm ? 8 : 12
    },
    onFilterChange: function (filter) {
      this.filter = filter
    },
    onNewItem: function () {
      this.item = this.defaultFormData
      this.showEditor(true, 'new')
    },
    onSelectItem: function (item) {
      if (item) {
        if (!item.location) {
          item.location = {
            latitude: null,
            longitude: null,
          }
        }
        if (item.attributes != null) {
          for (var a of item.attributes) {
            if (a.name == 'INFOPOINT_ID') {
              item.infopoint = parseInt(a.value)
              //alert("onSelectItem item.infopoint:" + item.infopoint);
              break
            }
          }
        }
        this.item = item
      }
      this.showEditor(true, 'edit')
    },
    onClose() {
      this.showEditor(false, '')
    },
  },
  computed: {
    formTitle() {
      return i18n.t('item.' + this.formType)
    },
  },
}
</script>
